import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";

const ListDatatable = ({ myData, myClass }) => {
  const [data, setData] = useState();
  useEffect(() => {
    setData(myData);
  }, [myData]);
  const columnDefs = [
    {
      name: "Profile",
      cell: (row) => <ProfileImage row={row} />,
    },
    {
      name: "Name",
      selector: (row) => row?.username,
      sortable: true,
    },
    {
      name: "User Type",
      selector: (row) => row?.userType,
      sortable: true,
    },
  ];

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};

const ProfileImage = ({ row }) => {
  return (
    <div className="profile-image">
      <img src={row.profile} alt="logo" className="rounded-0" />
    </div>
  );
};

export default ListDatatable;
